export default __webpack_public_path__ + "static/media/trustByStripe.a807a771.png";